import { Box, styled } from '@mui/material';
import { FIXED_FOOTER_HEIGHT } from 'src/constants';

export const Container = styled(Box)`
  max-height: calc(100% - ${FIXED_FOOTER_HEIGHT}px);
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled(Box)(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 30px;
    
    ${theme.breakpoints.up('md')} {
        flex-direction: row;
    }
  `,
);

export const FixedWidthColumn = styled(Box)`
  max-width: 18rem;
`;

export const FluidWidthColumn = styled(Box)`
  flex: 1;
  overflow: hidden;
`;

export const Content = styled(Box)`
  height: 100%;
  overflow-y: auto;
`;
